function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import classNames from "classnames";
import ErrorBoundary from "./ErrorBoundary";
var getBrowserInfo = function() {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
            name: "IE",
            version: tem[1] || ""
        };
    }
    if (M[1] === "Chrome") {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem) {
            return {
                name: "Opera",
                version: tem[1]
            };
        }
    }
    M = M[2] ? [
        M[1],
        M[2]
    ] : [
        navigator.appName,
        navigator.appVersion,
        "-?"
    ];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1]
    };
};
var bi = getBrowserInfo();
var loadedDate = new Date();
var canNavigate = function() {
    return !document.activeElement.matches(".DraftEditor-root");
};
var DebugConsole = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(DebugConsole, PureComponent);
    var _super = _createSuper(DebugConsole);
    function DebugConsole(props) {
        _classCallCheck(this, DebugConsole);
        var _this;
        _this = _super.call(this, props);
        _this.onKeyUp = function(evnt) {
            var _this_props = _this.props, open = _this_props.open, close = _this_props.close, visible = _this_props.visible;
            if ((evnt.key === "c" || evnt.key === "\xe7" || evnt.code === "KeyC") && evnt.ctrlKey && evnt.altKey && canNavigate()) {
                if (visible) {
                    close();
                } else {
                    open();
                }
            }
        };
        _this.renderMessage = function(message, i) {
            var timestamp = message.timestamp.getHours() + ":" + message.timestamp.getMinutes() + ":" + message.timestamp.getSeconds() + ":" + message.timestamp.getMilliseconds();
            var classes = classNames("debug-entry", "debug-entry--".concat(message.type));
            return /*#__PURE__*/ React.createElement("li", {
                className: classes,
                key: message.id
            }, /*#__PURE__*/ React.createElement("span", {
                className: "debug-entry__timestamp"
            }, timestamp), " ", "\xa0>\xa0", /*#__PURE__*/ React.createElement("span", {
                className: "debug-entry__message"
            }, !!message.label && /*#__PURE__*/ React.createElement("strong", null, message.label + ": "), " ", message.message));
        };
        _this.renderError = function(e) {
            var timestamp = e.timestamp.getHours() + ":" + e.timestamp.getMinutes() + ":" + e.timestamp.getSeconds() + ":" + e.timestamp.getMilliseconds();
            var classes = classNames("debug-entry", "debug-entry--error");
            return /*#__PURE__*/ React.createElement("li", {
                className: classes,
                key: e.id
            }, /*#__PURE__*/ React.createElement("span", {
                className: "debug-entry__timestamp"
            }, timestamp), " ", "\xa0>\xa0", /*#__PURE__*/ React.createElement("span", {
                className: "debug-entry__message"
            }, !!e.key && /*#__PURE__*/ React.createElement("strong", null, e.key + ": "), " ", e.error.message, " (", e.error.name, ")", " ", e.error.status !== undefined && "(".concat(e.error.status, ")")));
        };
        _this.state = {
            tab: "DEBUG"
        };
        return _this;
    }
    var _proto = DebugConsole.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        document.addEventListener("keyup", this.onKeyUp);
        window.toggleConsole = function() {
            var _this_props = _this.props, open = _this_props.open, close = _this_props.close, visible = _this_props.visible;
            if (visible) {
                close();
            } else {
                open();
            }
        };
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keyup", this.onKeyUp);
        window.toggleConsole = null;
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, messages = _this_props.messages, close = _this_props.close, visible = _this_props.visible, errors = _this_props.errors;
        var tab = this.state.tab;
        return visible && /*#__PURE__*/ React.createElement("div", {
            className: "debug-console",
            style: {
                minWidth: "500px"
            }
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement("div", {
            className: "debug-console__header"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "debug-console__info"
        }, bi.name, " ", bi.version, " / ", navigator.platform, " : cBOOK version", " ", window.cBOOK_VERSION, " "), /*#__PURE__*/ React.createElement("button", {
            className: "debug-console__zoom",
            onClick: window.zoomIn,
            title: "Zoom In"
        }, "+"), /*#__PURE__*/ React.createElement("button", {
            className: "debug-console__zoom",
            onClick: window.zoomOut,
            title: "Zoom Out"
        }, "-"), /*#__PURE__*/ React.createElement("button", {
            className: "debug-console__close",
            title: "Hide",
            "aria-label": "Hide",
            onClick: close
        }, /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": "true"
        }, "\xd7"))), !!errors.length && /*#__PURE__*/ React.createElement("div", {
            className: "debug-console__tabpane"
        }, /*#__PURE__*/ React.createElement("button", {
            className: classNames("debug-console__tab", {
                "debug-console__tab--active": tab !== "ERRORS"
            }),
            onClick: function() {
                return _this.setState({
                    tab: "DEBUG"
                });
            }
        }, "Debug"), /*#__PURE__*/ React.createElement("button", {
            className: classNames("debug-console__tab", "debug-console__tab--error", {
                "debug-console__tab--error--active": tab === "ERRORS"
            }),
            onClick: function() {
                return _this.setState({
                    tab: "ERRORS"
                });
            }
        }, "Errors (", errors.length, ")")), /*#__PURE__*/ React.createElement("div", {
            className: "debug-console__body"
        }, tab === "ERRORS" ? /*#__PURE__*/ React.createElement("ul", {
            className: "debug-console__log debug-console__log--errors"
        }, errors.map(this.renderError)) : /*#__PURE__*/ React.createElement("ul", {
            className: "debug-console__log"
        }, /*#__PURE__*/ React.createElement("li", {
            className: "debug-time"
        }, loadedDate.toUTCString()), messages.map(this.renderMessage)))));
    };
    return DebugConsole;
}(PureComponent);
export default DebugConsole;
